import React from 'react';

import { Box, Button, Typography } from '@mui/material';

import BaseDialog, { BaseDialogProps } from '../Base';

type Props = {
  state?: 'accept' | 'reject';
  selectedUsers: number;
  onAccept?: () => void;
} & BaseDialogProps;

export const ProductRequestsConfirmationDialog: React.FC<Props> = ({
  state = 'accept',
  selectedUsers,
  onAccept,
  ...restProps
}) => {
  return (
    <BaseDialog
      width='420px'
      height='290px'
      minHeight='290px'
      titleComponent={<></>}
      {...restProps}
    >
      <Box py={2}>
        <Typography fontSize={'18px'} fontFamily={'Poppins'} fontWeight={500} mb={1}>
          Confirm
        </Typography>
        <Typography fontSize={'15px'} fontFamily={'Poppins'} pr={5}>
          Are you sure you want to {state} the product request from {selectedUsers} users? Once
          accepted, they will become reservations.
        </Typography>

        <Box display={'flex'} gap={9} mt={5} ml={1}>
          <Button
            variant='text'
            color='primary'
            sx={{ fontWeight: 500, fontSize: '15px' }}
            onClick={() => {
              restProps?.onClose?.({}, 'backdropClick');
            }}
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            color='primary'
            sx={{ fontWeight: 500, fontSize: '15px', py: 2, textTransform: 'capitalize' }}
            fullWidth
            disabled={selectedUsers === 0}
            onClick={() => {
              if (onAccept) onAccept();
              restProps?.onClose?.({}, 'backdropClick');
            }}
          >
            {state} ({selectedUsers})
          </Button>
        </Box>
      </Box>
    </BaseDialog>
  );
};
